
  import { Vue, Component, Prop } from "vue-property-decorator";

  @Component({})
  export default class FormError extends Vue {
    @Prop({ type: String, default: "" }) readonly errorMessage!: string;
  }
